import { createReducer } from '@reduxjs/toolkit';
import { userActions } from '_actions';
import { log } from '_services'

let user = JSON.parse(localStorage.getItem('user'));
const initialState = user ? { loggedIn: true, user, sessionLoading: false } : { loggedIn: false, sessionLoading: false };

export const reducer = createReducer(initialState, {
    [userActions.loginRequest]: (state, action) => {
        state.loggingIn = true;
        state.user = action.payload;
    },
    [userActions.loginSuccess]: (state, action) => {
        state.loggingIn = false;
        state.loggedIn = true;
        state.user = action.payload;
    },
    [userActions.loginFailure]: (state, action) => {
        state.loggingIn = false;
        state.loggedIn = null;
        state.user = null;
        log.error('Login error for username: ' + action.payload.username + ' error: ' + action.payload.error);
    },

    [userActions.logoutSuccess]: (state, action) => {
        state.loggingIn = false;
        state.loggedIn = null;
        state.user = null;
    },

    [userActions.selectCompanyRequest]: (state, action) => {
        state.selectingCompany = true;
    },
    [userActions.selectCompanySuccess]: (state, action) => {
        state.selectingCompany = false;
        state.user = action.payload;
    },
    [userActions.selectCompanyFailure]: (state, action) => {
        state.selectingCompany = false;
        state.company = null;
        log.error('Error selecting company: ' + action.payload.companyId + ' error: ' + action.payload.error);
    },
    [userActions.loadSessionRequest]: (state, action) => {
        state.sessionLoading = true;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        state.sessionLoading = false;
    },
    [userActions.loadSessionFailure]: (state, action) => {
        state.sessionLoading = false;
    },
})

